import { IssuedConsumedRptService } from '../services';
import { IssuedConsumedRptConstants } from '../constants';
import { alertActions } from '.';

export const IssuedConsumedRptActions = {
    getAll,
    exportData,
    lodingData
};

function getAll(obj) {
    return dispatch => {
        dispatch(request());

        IssuedConsumedRptService.fetchFeedbackData(obj).then(response => {
            dispatch(lodingData(false));;
            dispatch(success(response.ResponseData))
        },
            error => {
                dispatch(lodingData(false));
                dispatch(failure(error.toString()));
                dispatch(alertActions.error(error.toString()));
            }

        );
    };
    function request() { return { type: IssuedConsumedRptConstants.GETALL_REQUEST } }
    function success(datas) { return { type: IssuedConsumedRptConstants.GETALL_SUCCESS, datas } }
    function failure(error) { return { type: IssuedConsumedRptConstants.GETALL_FAILURE, error } }
}


function exportData(obj) {
    return dispatch => {
        dispatch(request());
        IssuedConsumedRptService.fetchFeedbackData(obj).then(response => {
            dispatch(lodingData(false));
            var data = response.ResponseData;
            if (data != null) {
                data.forEach(function (v) {
                    delete v.TotalRows;
                });
            }
            dispatch(success(data))
        },
            error => {
                dispatch(failure(error.toString()));
                dispatch(alertActions.error(error.toString()));
            });
    };
    function request() { return { type: IssuedConsumedRptConstants.GETEXPORT_REQUEST } }
    function success(datas) { return { type: IssuedConsumedRptConstants.GETEXPORT_SUCCESS, datas } }
    function failure(error) { return { type: IssuedConsumedRptConstants.GETEXPORT_FAILURE, error } }
}

function lodingData(isbool) {
    return {
        type: IssuedConsumedRptConstants.LODING_REQUEST, isbool
    }
}

